import { createApi } from "@reduxjs/toolkit/query/react";

import { TagType } from "../enums";
import { generatedApiBaseQuery, sprengConnectApiBaseQuery } from "./sprengConnectApiBaseQuery";

export const sprengConnectApi = createApi({
  reducerPath: "sprengConnectApi",
  baseQuery: sprengConnectApiBaseQuery,
  endpoints: () => ({}),
  tagTypes: Object.values(TagType),
});

export const valuationReportApi = createApi({
  reducerPath: "valuationReportApi",
  baseQuery: generatedApiBaseQuery,
  endpoints: () => ({}),
  tagTypes: Object.values(TagType),
});
